import { Component, Input, Output, EventEmitter } from '@angular/core';
import { KeyValueSet, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss'
})
export class TabComponent {
  @Input() tabs: KeyValueSet[];
  @Input() selectedKey: string = '';
  @Output() selectedKeyChange = new EventEmitter();
  @Output() onTabSelected = new EventEmitter();
  @Input() isShowRefresh: boolean = false;
  @Output() onRefresh = new EventEmitter();

  tabWidth: number = 10; selectedIndex: number = 0;

  elementIds: any; htmlId: string = '';

  constructor(public localService: LocalService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      tab_container: 'tab-container-' + this.htmlId,
      tab_container_items: 'tab-container-items-' + this.htmlId,
      tab_container_action_1: 'tab-container-action-1' + this.htmlId,
      tab_container_action_2: 'tab-container-action-2' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.onLoad();
  }

  onLoad() {
    this.onSetContentWidth();
    if (!this.selectedKey && this.tabs && this.tabs.length > 0) {
      this.onAction(1, this.tabs[0].key);
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1:
      case 2: {
        if (this.selectedKey != key) {
          this.selectedKey = key;
          this.selectedIndex = this.tabs.findIndex(x => x.key == this.selectedKey);
          this.onSetScrollBar();
          if (index == 2) {
            this.selectedKeyChange.emit(key);
            this.onTabSelected.emit(key);
          }
        }
      } break;
      case 3: {
        this.selectedIndex = this.tabs.findIndex(x => x.key == this.selectedKey);
        if (key == '-1') {
          if (this.selectedIndex > 0) {
            this.selectedIndex--;
          }
        } else {
          if (this.selectedIndex < this.tabs.length - 1) {
            this.selectedIndex++;
          }
        }
        this.onAction(2, this.tabs[this.selectedIndex].key);
      } break;
      case 4: {
        this.onRefresh.emit();
      } break;
    }
  }

  onResize(e) {
    this.onSetContentWidth(500);
  }

  onSetContentWidth(delay = 0) {
    setTimeout(() => {
      const element_tab_container = document.getElementById(this.elementIds.tab_container);
      if (element_tab_container) {
        let actionWidth1: number = 0;
        const element_tab_container_action_1 = document.getElementById(this.elementIds.tab_container_action_1);
        if (element_tab_container_action_1) {
          actionWidth1 = element_tab_container_action_1.clientWidth;
          this.tabWidth = element_tab_container.clientWidth - element_tab_container_action_1.clientWidth;
        }
        let actionWidth2: number = 0;
        const element_tab_container_action_2 = document.getElementById(this.elementIds.tab_container_action_2);
        if (element_tab_container_action_2) {
          actionWidth2 = element_tab_container_action_2.clientWidth;
        }

        this.tabWidth = element_tab_container.clientWidth - (actionWidth1 + actionWidth2);
      }
    }, delay);
  }

  onSetScrollBar() {
    let element_tab_container_items = document.getElementById(this.elementIds.tab_container_items);
    if (element_tab_container_items) {
      const currentIndex = this.tabs.findIndex(x => x.key == this.selectedKey);
      let previousWidth = 0;
      if (currentIndex > 0) {
        for (var i = 0; i < currentIndex; i++) {
          const elementTab = document.getElementById(this.elementIds.tab_container_items + '-' + i);
          if (elementTab) {
            previousWidth += elementTab.clientWidth;
          }
        }
      }
      const elementTab = document.getElementById(this.elementIds.tab_container_items + '-' + currentIndex);
      if (elementTab) {
        element_tab_container_items.scrollLeft = previousWidth;
      }
    }
  }
}
